<template>
  <el-card shadow="never" class="active-card">
    <h4>活动数据</h4>
    <template>
      <div class="list-box">
        <div class="item">
          <div :class="['top', 'top0']">
            <span class="title" slot="reference">{{activeInfo.thresholdIndexType === 1 ? '累计总流水' : '累计订单笔数'}}</span>
            <el-popover
              placement="top-start"
              width="400"
              trigger="hover">
              <div>
                <template v-if="activeInfo.thresholdIndexType === 1">
                  <span>油站活动开始到现在的累积交易流水；</span><br/>
                </template>
                <template v-if="activeInfo.thresholdIndexType === 2">
                  <span>油站活动开始到现在的累积交易订单笔数；</span><br/>
                </template>
                活动开始 到 活动结束的订单，在活动开始和活动结束后7天内如果状态是退款中和已退款不计入；<br/>
                活动结束7天后，不再更新数据；
              </div>
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
            <p>
              <span class="data">{{ accumulativeTotalFlow }}</span>
              <span class="yuan">{{activeInfo.thresholdIndexType === 1 ? '元' : '笔'}}</span>
            </p>
          </div>
        </div>
      </div>
    </template>
    <!-- <NoData errTitle="暂无数据" setHeight="200px"></NoData> -->
  </el-card>
</template>
<script>
// import NoData from "@/components/base/no-data"
export default {
  props: {
    activeInfo: Object
  },
  // components: {NoData},
  data () {
    return {
      showDetail: false,
      accumulativeTotalFlow: 0
    }
  },
  methods: {
    init () {
      this.accumulativeTotalFlow = this.activeInfo.accumulativeTotalFlow
    },
  }
}
</script>
<style lang="less" scoped>
@import url('../mixin.less');
</style>